import client from '../httpClient';

const actCreateHistoryApi = (params) => {
  return client.post('/actions/histories/', JSON.stringify(params), { isShowLoading: false });
};

export default actCreateHistoryApi;
